var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagNato(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_16084)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8666 17.1164C22.9254 16.7528 22.9565 16.38 22.9565 16.0001C22.9565 16.38 22.9254 16.7528 22.8666 17.1164L25.7391 16.0001L22.8666 14.8839L21.2887 14.2709L18.7253 13.2748L17.7292 10.7114C19.4089 11.2619 20.7381 12.5911 21.2887 14.2708L22.8665 14.8839C22.3897 11.9404 20.0596 9.61024 17.1162 9.13349L16 6.26099L14.8837 9.13355C11.9402 9.61042 9.61024 11.9404 9.13343 14.8839L6.26086 16.0001L9.13349 17.1164C9.6103 20.0599 11.9403 22.3899 14.8838 22.8667L16 25.7392L17.1162 22.8667C20.0597 22.3899 22.3897 20.0598 22.8666 17.1164ZM17.6505 14.3497L16 16.0001H21.8978L17.6504 17.6506L16 16.0001V21.898L14.3495 17.6505L16 16.0001H10.1022L14.3495 14.3497L16 16.0001V10.1023L17.6505 14.3497ZM14.2707 10.7114L13.2746 13.2749L10.7112 14.2709C11.2618 12.5911 12.591 11.262 14.2707 10.7114ZM10.7113 17.7294L13.2746 18.7255L14.2707 21.2888C12.591 20.7382 11.2619 19.4091 10.7113 17.7294ZM17.7293 21.2888L18.7254 18.7255L21.2887 17.7294C20.7381 19.4091 19.409 20.7382 17.7293 21.2888Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8978 16H16L17.6505 17.6505L21.8978 16Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1025 16H16.0004L14.3499 14.3496L10.1025 16Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0004 21.8979V16L14.3499 17.6505L16.0004 21.8979Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 16.0001L17.6505 14.3497L16 10.1023V16.0001Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3047 2.08691H16.696V4.86954H15.3047V2.08691Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.08691 15.3044H4.86954V16.6958H2.08691V15.3044Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3047 27.1304H16.696V29.913H15.3047V27.1304Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1309 15.3044H29.9135V16.6958H27.1309V15.3044Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_16084"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagNato);
export default __webpack_public_path__ + "static/media/flag_nato.c3caa5c24be2a30d66733cdae3b373fb.svg";
export { ForwardRef as ReactComponent };